import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/analytics")({
  component: RouteComponent,
});

function RouteComponent() {
  // For global analytics, we could show all projects or require project selection
  // For now, let's show a demo with placeholder data

  return (
    <div className="container mx-auto p-6">
      <div className="py-12 text-center">
        <h1 className="mb-4 text-2xl font-bold">Analytics Dashboard</h1>
        <p className="text-muted-foreground mb-6">
          View notification logs and analytics across all your projects.
        </p>
        <p className="text-muted-foreground mb-8 text-sm">
          Navigate to Projects → [Your Project] to see detailed analytics for specific projects.
        </p>

        {/* Demo Dashboard */}
        <div className="mt-8">
          {/* <NotificationLogsDashboard projectId={"demo-project-id" as ProjectsId} /> */}
        </div>
      </div>
    </div>
  );
}
